export const projects = [
  {
    img:
      "https://github.com/Mamata24/Delivary.com/raw/main/Images/Landing_Page.PNG",
    title: "Delivary.com",
    des:
      "Delivary.com is a clone of delivery.com, an international based food delivery application, that enables users to order from local restaurants and stores for on-demand delivery.",
    demo: "https://www.youtube.com/watch?v=o5QBD574_mY&t=2s",
    live: "",
    gitHub: "https://github.com/Mamata24/Delivary.com",
    technologies: ["React", "Redux", "HTML", "CSS", "javaScript", "Node"],
  },
  {
    img: "expenseManager.png",
    title: "Expense Manager",
    des: "An application that enables users to track their expenses.",
    demo: "https://www.youtube.com/watch?v=figSFT9gf1Y",
    live: "https://expense-manager-ochre.vercel.app/",
    gitHub: "https://github.com/revanthraghu/Expense-Manager",
    technologies: ["React", "Redux", "HTML", "CSS", "javaScript", "Node"],
  },
  {
    img: "bailly.png",
    title: "Bailly",
    des:
      "This is an e-commerce website dedicated to perfumes alone. It is complete with a Login page, Sign-in page, Shopping Cart, Wishlist and adding favorites.",
    demo: "https://www.youtube.com/watch?v=3WE5I3BAxfE",
    live: "",
    gitHub:
      "https://github.com/masai-course/ac_009_akhila/tree/master/week_23/day_2/assignments/bailly",
    technologies: ["HTML", "CSS", "javaScript", "Bootstrap", "React"],
  },
  {
    img: "hirato.png",
    title: "Hirato",
    des:
      "This is a Hotel Management app. This app includes landing, pricing, our story, and allows users to book a room.",
    demo: "https://www.youtube.com/watch?v=3aUItosrWtE",
    live: "https://hirato.vercel.app/",
    gitHub: "https://github.com/vchandu111/Hotel-Management-System",
    technologies: ["HTML", "CSS", "javaScript", "Bootstrap"],
  },
  {
    img: "learnorb.png",
    title: "LearnOrb",
    des:
      "A simple implementation of Online Courses Website where the user has to pass an exam in order to view the courses.",
    demo: "https://youtu.be/CwZDAxgoFm0",
    live: "https://learn-orb-chi.vercel.app/",
    gitHub: "https://github.com/AkhilaG28/LearnOrb",
    technologies: ["HTML", "CSS", "javaScript", "Bootstrap"],
  },
  {
    img: "zerodha.png",
    title: "Clone of Zerodha",
    des: "This is a clone of Zerodha website with a few static pages.",
    demo: "https://youtu.be/wkRNp5AdzWE",
    live: "",
    gitHub:
      "https://github.com/masai-course/ac_009_akhila/tree/master/week_23/day_1/assignments/zeroda",
    technologies: ["React", "HTML", "CSS", "javaScript", "Bootstrap"],
  },
];
